const sendLoanFpoFields = [
  {
    type: "select",
    label: "Lender",
    name: "lender",
  },
  {
    type: "text",
    label: "Amount (INR)",
    name: "amount",
  },
  {
    type: "select",
    label: "Loan Type",
    name: "loan_type",
    options: [
      { value: "Working Capital", label: "Working Capital" },
      { value: "Invoice Finance", label: "Invoice Finance" },
      { value: "Warehouse Finance", label: "Warehouse Finance" },
      { value: "Others", label: "Others" },
    ],
  },
];

const farmFields = [
  {
    type: "text",
    label: "Farm Name",
    name: "farm_name",
    required: true,
  },
  {
    type: "text",
    label: "Regulator(Record keeper agency of govt)",
    name: "regulator",
  },
  {
    type: "text",
    label: "Land Record Number",
    name: "land_record_number",
  },
  {
    type: "number",
    label: "PIN/ZIP Code",
    name: "pin_code",
  },
  {
    type: "checkboxes",
    label: "Irrigation Source",
    name: "irrigation_source",
    required: true,
    multiple: true,
  },
  {
    type: "checkboxes",
    label: "Irrigation System",
    name: "irrigation_system",
    required: true,
    multiple: true,
  },
  {
    type: "select",
    label: "Soil Texture",
    name: "soil_texture",
    required: true,
  },

  {
    type: "select",
    label: "Owner Type",
    name: "owner_type",
    required: true,
  },

  {
    type: "file",
    label: "Legal Document",
    name: "land_doc",
    accept: ".pdf, .jpeg, .jpg, .heic, .png",
    optional: true,
  },
  {
    type: "text",
    label: "Owner Name",
    name: "owner_name",
    required: true,
  },
  {
    type: "map",
    label: "Farm Location",
    name: "farm_location",
    required: true,
  },
  {
    type: "number",
    label: "Area (in acres)",
    name: "area",
    required: true,
  },
  {
    type: "file",
    label: "Farm Photo",
    name: "farm_doc",
    accept: "image/*",
    capture: "environment",
    optional: true,
  },
];

const lenderProfile = [
  {
    type: "file",
    label: "Lender Logo",
    name: "lender_logo",
    accept: "image/*",
    capture: "environment",
    optional: true,
  },
  {
    type: "range_values",
    label: "Loan Rate%",
    name: "interest_rate_min",
    name2: "interest_rate_max",
    required: true,
    title: "Enter Interest Rate(% per annum)",
  },
  {
    type: "number",
    label: "Loan amount",
    name: "loan_amount",
    required: true,
    title: "Enter loan amount(up to)",
  },
  {
    type: "number",
    label: "Loan tenure",
    name: "loan_tenure_months",
    required: true,
    title: "Enter loan tenure(up to)",
  },
  {
    type: "number",
    label: "Revenue required",
    name: "minimum_revenue",
    required: true,
    title: "Minimum revenue required",
  },
  {
    type: "checkboxes",
    label: "Documents Required",
    name: "required_documents",
    required: true,
    multiple: true,
  },
];

const requirementsBuyer = [
  {
    type: "select",
    label: "Commodity",
    name: "commodity",
    required: true,
  },
  {
    type: "number",
    label: "Quantity (KG)",
    name: "quantity",
    required: true,
  },
  {
    type: "date",
    label: "Date Needed on",
    name: "date_needed",
    required: true,
  },
  {
    type: "number",
    label: "Max Price",
    name: "max_price",
    required: true,
  },
  {
    type: "text",
    label: "Quality Requirement",
    name: "quality_requirement",
    required: true,
  },
  {
    type: "select",
    label: "Who can Respond?",
    name: "responder_type",
    options: [
      { value: "FPO", label: "FPO" },
      { value: "Aggregator", label: "Aggregator" },
      { value: "Farmer", label: "Farmer" },
      { value: "Anyone", label: "Anyone" },
    ],
    required: true,
  },
  {
    type: "number",
    label: "Pincode",
    name: "pin_code",
    required: true,
  },
];

const buyingInterest = [
  {
    type: "number",
    label: "Quantity (KG)",
    name: "quantity",
    required: true,
  },
  {
    type: "date",
    label: "Date Needed on",
    name: "date",
    required: true,
  },
  {
    type: "number",
    label: "Pincode",
    name: "pin_code",
    required: true,
  },
];

const buyerProfile = [
  {
    type: "text",
    label: "Brand Name",
    name: "brand_name",
    required: true,
  },
  {
    type: "text",
    label: "Headquarter Location",
    name: "headquarter_location",
    placeholder: "Mumbai",
    required: true,
  },
  {
    type: "text",
    label: "Geographical Presence",
    name: "geographical_presence",
    placeholder: "Maharashtra, Delhi...",
    required: true,
  },
  {
    type: "text",
    label: "Products Of Interest",
    name: "products_of_interest",
    placeholder: "Coffee, Rice...",
    required: true,
  },
  {
    type: "text",
    label: "Nature Of Interest",
    name: "nature_of_interest",
    placeholder: "Restaurants, Supermarket...",
    required: true,
  },
  {
    type: "text",
    label: "Contact Person Name",
    name: "contact_person_name",
    required: true,
  },
  {
    type: "number",
    label: "Contact Person Phone Number",
    name: "contact_person_phone_number",
    required: true,
  },
];

function CropFields(t, farms, commodity) {
  return [
    {
      label: t("Farm"),
      name: "farmland",
      type: "select",
      options: farms.map((farm) => ({
        value: farm.id,
        label: farm.farm_name,
      })),
      required: true,
    },
    {
      label: t("Crop Type"),
      name: "commodity",
      type: "select",
      options: commodity.map((commodity) => ({
        value: commodity.id,
        label: commodity.name,
      })),
      required: true,
    },
    {
      name: "is_ratoon",
      label: t("Is Ratoon Crop?"),
      type: "checkbox",
    },
    {
      label: t("Sowing Date"),
      name: "sowing_date",
      type: "date",
      required: true,
    },
    {
      label: t("Seed Name"),
      name: "seed_type",
      type: "text",
    },
    {
      label: t("Seed Source"),
      name: "seed_source",
      type: "text",
    },
    {
      label: t("Sowing Source"),
      name: "sowing_source",
      type: "select",
      options: [
        { value: "SEED", label: t("Seed") },
        { value: "SAPLING", label: t("Sapling") },
      ],
    },
    {
      label: t("Seed Quantity(kg)"),
      name: "seed_quantity",
      type: "number",
    },
    {
      label: t("Number of Saplings"),
      name: "sapling_quantity",
      type: "number",
    },
    {
      label: t("Estimated Harvested Amount(Kg)"),
      name: "estimated_harvest",
      type: "number",
    },
    {
      label: t("Estimated Harvest Date"),
      name: "estimated_harvest_date",
      type: "date",
    },
  ];
}

function PlantationFields(t, farms, commodity) {
  return [
    {
      label: t("Farm"),
      name: "farmland",
      type: "select",
      options: farms.map((farm) => ({
        value: farm.id,
        label: farm.farm_name,
      })),
    },
    {
      label: t("Species Type"),
      name: "commodity",
      type: "select",
      options: commodity.map((commodity) => ({
        value: commodity.id,
        label: commodity.name,
      })),
    },
    {
      label: t("Planting Date"),
      name: "sowing_date",
      type: "date",
    },
    {
      label: t("Nursery Name"),
      name: "nursery_name",
      type: "text",
    },
    {
      label: t("Nursery Location"),
      name: "nursery_location",
      type: "text",
    },
    {
      label: t("Plantation Method"),
      name: "plantation_method",
      type: "text",
    },
    {
      label: t("Pit Size (cm)"),
      name: "pit_size",
      type: "number",
    },
    {
      label: t("Plant Count"),
      name: "plant_count",
      type: "number",
    },
  ];
}

const getSoilTestFields = (t, farms, testMode = "device") => {
  const baseFields = [
    {
      label: t("Farm"),
      name: "farm_land",
      type: "select",
      options: farms.map((farm) => ({
        value: farm.id,
        label: `${farm.id} - ${farm.farm_name}`,
      })),
    },
  ];

  if (testMode === "manual") {
    return [
      ...baseFields,
      {
        label: t("Crop"),
        name: "crop",
        type: "select",
        required: false,
        options: [],
      },
      {
        label: t("pH Level"),
        name: "ph",
        type: "number",
        required: true,
        placeholder: "7.0",
      },
      {
        label: t("Nitrogen (N) kg/ha"),
        name: "nitrogen",
        type: "number",
        required: true,
        placeholder: "Available Nitrogen",
      },
      {
        label: t("Phosphorus (P) kg/ha"),
        name: "phosphorus",
        type: "number",
        required: true,
        placeholder: "Available Phosphorus",
      },
      {
        label: t("Potassium (K) kg/ha"),
        name: "potassium",
        type: "number",
        required: true,
        placeholder: "Available Potassium",
      },
      {
        label: t("Organic Carbon (%)"),
        name: "organic_carbon",
        type: "number",
        required: true,
        placeholder: "0.1 - 2.0",
      },
    ];
  }

  return baseFields;
};

const getExternalSoilTestFields = (t) => [
  {
    label: t("Identifier"),
    name: "report_id",
    type: "text",
  },
  {
    label: t("Requester Name"),
    name: "name",
    type: "text",
  },
  {
    label: t("Requester Mobile"),
    name: "mobile",
    type: "tel",
  },
  {
    label: t("Pincode"),
    name: "pincode",
    type: "text",
  },
];

const fpoInterestFormFields = (t) => [
  { name: "fpo_name", label: t("FPO Name"), type: "text" },
  {
    name: "contact_person_name",
    label: t("Contact Person Name"),
    type: "text",
  },
  { name: "contact", label: t("Mobile"), type: "number" },
  { name: "location", label: t("Location"), type: "text" },
  {
    name: "total_number_of_farmers",
    label: t("Total Number of Farmers"),
    type: "number",
  },
  { name: "total_acreage", label: t("Total Acreage"), type: "number" },
  {
    name: "interested_in",
    label: t("Interested In"),
    type: "select",
    options: [
      { value: "buying", label: t("Buying") },
      { value: "selling", label: t("Selling") },
    ],
  },
];

const commodityDetailFields = (t, commodityOptions, availability) => [
  {
    name: "commodity",
    label: t("Commodity"),
    type: "select",
    options: commodityOptions.map((option) => ({
      value: option.id,
      label: option.name,
    })),
  },
  {
    name: "quantity",
    label: t("Quantity"),
    type: "number",
  },
  {
    name: "availability",
    label: t("Availability"),
    type: "select",
    options: [
      { value: "instantly", label: t("Instantly") },
      { value: "future", label: t("Future") },
    ],
  },
  ...(availability === "future"
    ? [
        {
          name: "harvest_date",
          label: t("Harvest Date"),
          type: "date",
        },
      ]
    : []),
];

const getOrderDetailsFields = (t) => {
  return [
    {
      name: "requested_quantity",
      label: t("Requested Quantity (kg)"),
      type: "number",
      required: true,
    },
    {
      name: "cost_per_kg",
      label: t("Cost Per Kg (Rs.)"),
      type: "number",
      required: true,
    },
    {
      name: "delivery_charges",
      label: t("Delivery Charges (Rs.)"),
      type: "number",
    },
    {
      name: "packaging_charges",
      label: t("Packaging Charges (Rs.)"),
      type: "number",
    },
    {
      name: "commission",
      label: t("Commission (Rs.)"),
      type: "number",
    },
  ];
};

const getTypeSpecificFields = (t, orderType) => {
  const normalizedOrderType =
    orderType.toLowerCase() === "farmer" ? "farmer" : "institution";

  return normalizedOrderType === "farmer"
    ? [
        { name: "farmerId", label: t("Farmer ID"), required: true },
        { name: "farmId", label: t("Farm ID"), required: true },
      ]
    : [
        {
          name: "institutionName",
          label: t("Institution Name"),
          required: true,
        },
        {
          name: "institutionPhoneNumber",
          label: t("Institution Phone Number"),
          required: true,
        },
      ];
};

const personalInfoFields = [
  { name: "name", label: "Name", required: true, type: "text", sm: 6 },
  {
    name: "organization",
    label: "Organization (if applicable)",
    required: false,
    type: "text",
    sm: 12,
  },
  { name: "email", label: "Email", required: false, type: "email", sm: 6 },
  {
    name: "phone_number",
    label: "Phone Number",
    required: true,
    type: "text",
    sm: 6,
    maxLength: 10,
  },
];

export {
  sendLoanFpoFields,
  farmFields,
  lenderProfile,
  requirementsBuyer,
  buyingInterest,
  buyerProfile,
  personalInfoFields,
  CropFields,
  PlantationFields,
  getSoilTestFields,
  fpoInterestFormFields,
  commodityDetailFields,
  getExternalSoilTestFields,
  getOrderDetailsFields,
  getTypeSpecificFields,
};
